
// Parent Modules
import { hero } from './modules/hero';
import { locationsList } from './modules/locations-list';
import { moduleMap } from './modules/map';
// import newsletterSignup from './modules/newsletter-signup';
import { promoSlider } from './modules/promo-slider';
import { imageSlider } from './modules/image-slider';
import { videoPlayer } from './modules/video-player';
import { moduleSpacesFeed } from './modules/private-event-spaces-feed';
import { moduleMenus } from './modules/menus';
import { faqsJS } from './modules/faqs';
import { eventsFeed } from './modules/events-feed';
import { filteredEventsFeed } from './modules/filtered-events-feed';

import { hoverVideo } from './functions/hover-video';
import { inlineVideo } from './functions/inline-video';
import { popupNav } from './functions/popup-nav';
import { closePopupsButtonWatcher, newsletterSignupForm, hijackDMNForm, hijackOTForm, triggerCustomPopups } from './functions/popups';
// import { urlParams } from './functions/url-params';


//Child Theme Specific JS
import './components/atreemoForm';

import { urlParams } from './functions/url-params';
import { moduleFuseFeed } from '../js/modules/fuse-feed';
import { cardSlider } from '../js/modules/card-slider';
//import { toggleCursor } from './components/cursor';
import { fadeOnScroll } from './components/fade-on-scroll';
import { header } from './components/header';
import { menus } from './functions/menus';




export default initJS = () => {

	document.querySelector('body').classList.remove('no-js');
	document.querySelector('#js__body').classList.remove('no-js');

	//Modules
	hero();
	cardSlider();
	moduleMap();
	promoSlider();
	imageSlider();
	videoPlayer();
	moduleSpacesFeed();
	moduleFuseFeed();
	moduleMenus();
	faqsJS();
	locationsList();
	eventsFeed();
	filteredEventsFeed();

	//Global Parent Functions
	header();
	popupNav();
	closePopupsButtonWatcher();
	triggerCustomPopups();
	urlParams();
	hoverVideo();
	inlineVideo();
	fadeOnScroll();
	newsletterSignupForm();
	hijackDMNForm();
	hijackOTForm();
	menus();



}